var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5835 21.25L13.7502 17.3104L18.9168 21.25L16.9793 14.8563L22.146 11.175H15.8168L13.7502 4.45833L11.6835 11.175H5.35433L10.521 14.8563L8.5835 21.25ZM13.7502 26.4167C11.9634 26.4167 10.2842 26.0776 8.71266 25.3995C7.14113 24.7214 5.77412 23.801 4.61162 22.6385C3.44912 21.476 2.52881 20.109 1.85068 18.5375C1.17256 16.966 0.833496 15.2868 0.833496 13.5C0.833496 11.7132 1.17256 10.034 1.85068 8.4625C2.52881 6.89097 3.44912 5.52396 4.61162 4.36146C5.77412 3.19896 7.14113 2.27865 8.71266 1.60052C10.2842 0.922396 11.9634 0.583334 13.7502 0.583334C15.537 0.583334 17.2161 0.922396 18.7877 1.60052C20.3592 2.27865 21.7262 3.19896 22.8887 4.36146C24.0512 5.52396 24.9715 6.89097 25.6496 8.4625C26.3278 10.034 26.6668 11.7132 26.6668 13.5C26.6668 15.2868 26.3278 16.966 25.6496 18.5375C24.9715 20.109 24.0512 21.476 22.8887 22.6385C21.7262 23.801 20.3592 24.7214 18.7877 25.3995C17.2161 26.0776 15.537 26.4167 13.7502 26.4167ZM13.7502 23.8333C16.6349 23.8333 19.0783 22.8323 21.0804 20.8302C23.0825 18.8281 24.0835 16.3847 24.0835 13.5C24.0835 10.6153 23.0825 8.17188 21.0804 6.16979C19.0783 4.16771 16.6349 3.16667 13.7502 3.16667C10.8654 3.16667 8.42204 4.16771 6.41995 6.16979C4.41787 8.17188 3.41683 10.6153 3.41683 13.5C3.41683 16.3847 4.41787 18.8281 6.41995 20.8302C8.42204 22.8323 10.8654 23.8333 13.7502 23.8333Z",
    fill: "url(#paint0_linear_765_208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_765_208",
    x1: 13.7502,
    y1: 0.583334,
    x2: 13.7502,
    y2: 26.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/Star-outlined.592f49f5fc1891581598c956b247fdb3.svg";
export { ForwardRef as ReactComponent };